import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, skip, takeUntil } from 'rxjs/operators';
import { AccountInfoService } from '~app/core/modules/identity/services/account-info.service';
import { environment } from '~env/environment';
import { BUY_AGAIN, BUY_AGAIN_EXTERNAL, YOUR_ASSORTMENT_EXTERNAL } from '~shared/constants';

@Component({
  selector: 'app-access-denied',
  styleUrls: ['./access-denied.component.scss'],
  templateUrl: './access-denied.component.html',
})
export class AccessDeniedComponent implements OnInit, OnDestroy {
  private readonly customerSupportUrl = 'https://metro-markets.freshdesk.com/support/tickets/new';
  private unsubscribe$ = new Subject<void>();
  constructor(private readonly accountInfoService: AccountInfoService, private readonly router: Router) {}

  ngOnInit(): void {
    this.subscribeForContextChange();
  }

  private subscribeForContextChange(): void {
    this.accountInfoService
      .getAccountInfo()
      .pipe(
        takeUntil(this.unsubscribe$),
        skip(1),
        filter((accountInfo) => accountInfo !== null)
      )
      .subscribe((accountInfo) => {
        if (accountInfo.isSubsidiary) {
          window.location.href = YOUR_ASSORTMENT_EXTERNAL();
        } else {
          window.location.href = BUY_AGAIN_EXTERNAL();
        }
      });
  }
  navigateToCustomerSupport(): void {
    window.location.href = this.customerSupportUrl;
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
